/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountHandle.defs'
export { main as default } from './updateAccountHandle.defs'
